import React, { useEffect } from 'react';

// material-ui
import {
    Button,
    FormHelperText,
    Grid,
    TextField
} from '@mui/material';

// project Import
import useApi from 'hooks/useApi';
import MasterService from 'services/MasterService';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import validationSchema from 'utils/schema/ConvenienceFeeSchema';

// third party
import { useFormik } from 'formik';

export default function ConvenienceFee() {

    const updateConvenienceFee = () => {
        const formikValues = { ...formik.values };
        updateConvenienceFeeApi.execute(formikValues);
    };

    const formik = useFormik({
        initialValues: { convenience_fee_percentage: '' },
        validationSchema: validationSchema,
        onSubmit: updateConvenienceFee
    });

    const getPriceListHandler = (response) => {
        const data = response.data;
        if (data.convenience_fee_percentage >= 0) {
            formik.setFieldValue('convenience_fee_percentage', data.convenience_fee_percentage);
        }
    };

    const getConvenienceListApi = useApi(MasterService.getConvenienceList, getPriceListHandler);
    const updateConvenienceFeeApi = useApi(MasterService.createConvenience, () => { }, true);

    useEffect(() => {
        getConvenienceListApi.execute();
    }, []);

    return (
        <MainCard>
            <Grid container spacing={gridSpacing} justifyContent="center">
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        label="Convenience Fee(%)"
                        name="convenience_fee_percentage"
                        error={Boolean(formik.touched.convenience_fee_percentage && formik.errors.convenience_fee_percentage)}
                        value={formik.values.convenience_fee_percentage}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                    />
                    {formik.touched.convenience_fee_percentage && formik.errors.convenience_fee_percentage && (
                        <FormHelperText error id="standard-weight-helper-text-convenience_fee_percentage">
                            {formik.errors.convenience_fee_percentage}
                        </FormHelperText>
                    )}
                </Grid>
                <Grid item xs={2} sx={{ marginTop: '6px' }}>
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={formik.handleSubmit}
                    >
                        Update
                    </Button>
                </Grid>
            </Grid>
        </MainCard>
    );
};